<mat-form-field 
appearance="fill" class="component-box" [formGroup]="group" [ngClass]="{'error-border':required}">
<mat-label>{{label}}{{required?" (Required)":""}}</mat-label>
<button type="button"
   mat-icon-button
   matSuffix
   *ngIf="group.controls?.[controlName]?.value && clearSeleAvailable"
   aria-label="Clear"
   (click)="clearSelection()"
   class="cross-btn">
  <f-icon icon-config='{"iconName": "xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
</button>

    <input matInput [formControlName]="controlName" 
    [matAutocomplete]="auto" #inputClient    
      [appAutoFocus]="autofocus"  (blur)="this.onblur($event)"/>
    <mat-autocomplete   [disabled]='disable'  disableRipple  [appAutoFocus]="autofocus" 
    id="{{label}}" #auto="matAutocomplete" (optionSelected)="typeHeadChange($event)" >
        <mat-option  class="custom-option" *ngFor="let item of filteredList" 
        [name]="item[description]" [title]="item[description]" [value]="item.clientName" >
            {{ item.clientName }}
        </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="required && group.controls[controlName].hasError('required')"> 
        <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
        You must first select a {{label}}. 
    </mat-error>
    <mat-error *ngIf="group.get(controlName)?.hasError('invalidClient')">
        <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> Invalid Client
      </mat-error>   
      <mat-error *ngIf="group.get(controlName)?.hasError('invalidDashboardClient')">
        <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> Invalid Client
      </mat-error>   
    
  

</mat-form-field>